import axios from "axios";
import { loadIdentity } from "./identity";
import { signedGet, signedPost } from "./signedRequest";
import { REQUEST_TIMEOUT_MS } from "./apiConstants";

const API = process.env.REACT_APP_BACKEND_URL || "";

export async function fetchFollowStatus(followeeId) {
  const viewer = loadIdentity();
  const headers = viewer?.identityId ? { "x-ol-identity": viewer.identityId } : {};
  const r = await axios.get(
    `${API}/api/v1/follows/${encodeURIComponent(followeeId)}/status`,
    { headers, timeout: REQUEST_TIMEOUT_MS },
  );
  return r.data; // { following, followers }
}

export async function toggleFollow(followeeId, action) {
  const me = loadIdentity();
  if (!me) throw new Error("Identità non trovata");
  const r = await signedPost(`/api/v1/follows`, {
    followerId: me.identityId,
    followeeId,
    action,
  });
  return r.data;
}

export async function fetchProfile(identityId) {
  const r = await axios.get(
    `${API}/api/v1/profiles/${encodeURIComponent(identityId)}`,
    { timeout: REQUEST_TIMEOUT_MS },
  );
  return r.data.profile;
}


export async function fetchMyNetwork() {
  const me = loadIdentity();
  if (!me) throw new Error("Identità non trovata");
  const r = await axios.get(`${API}/api/v1/follows/me/network`, {
    headers: { "x-ol-identity": me.identityId },
    timeout: REQUEST_TIMEOUT_MS,
  });
  return r.data;
}

export async function fetchBlockStatus(identityId) {
  const r = await signedGet(`/api/v1/blocks/${encodeURIComponent(identityId)}/status`);
  return r.data;
}

export async function toggleUserBlock(blockedId, action) {
  const r = await signedPost("/api/v1/blocks", { blockedId, action });
  return r.data;
}


export async function updateProfileBio({ bio = null } = {}) {
  const r = await signedPost("/api/v1/profiles/me/bio", {
    bio,
  });

  return r.data?.profile || r.data;
}

export async function updateProfileCover({
  objectKey = null,
  kind = null,
  moderationStatus = null,
} = {}) {
  const r = await signedPost("/api/v1/profiles/me/cover", {
    coverObjectKey: objectKey,
    coverKind: kind,
    coverModerationStatus: moderationStatus,
  });

  return r.data?.profile || r.data;
}
